import React, { useEffect } from 'react';
import './landing.css';
import { useReveal } from './hooks';
import { StoreModalProvider } from './storeModalContext';
import Nav from './Nav';
import Hero from './Hero';
import Problem from './Problem';
import Sheikh from './Sheikh';
import Topics from './Topics';
import Proof from './Proof';
import Faq from './Faq';
import CtaFinal from './CtaFinal';
import Footer from './Footer';
import StoreModal from './StoreModal';

const Home: React.FC = () => {
  useReveal();

  useEffect(() => {
    document.body.classList.add('niyyah-landing-body');
    return () => {
      document.body.classList.remove('niyyah-landing-body');
    };
  }, []);

  return (
    <StoreModalProvider>
      <Nav />
      <Hero />
      <Problem />
      <Sheikh />
      <Topics />
      <Proof />
      <Faq />
      <CtaFinal />
      <Footer />
      <StoreModal />
    </StoreModalProvider>
  );
};

export { Home };
